import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { PaymentStatus } from '../../models/payment/payment-status';

@Component({
  selector: 'psc-payment-status-text',
  standalone: true,
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'payment', alias: 'payment' } }],
  imports: [CommonModule, TranslocoModule],
  templateUrl: './payment-status-text.component.html',
})
export class PaymentStatusTextComponent {
  @Input() withTitle: boolean;
  @Input() status: PaymentStatus;

}
